import React, { useState } from "react";
import { Select } from "antd";
import CategorywiseSales from "./categorywise-sales";
import SubCategorywiseSales from "./sub-categorywise-sales";

const { Option } = Select;

export default function CategoryBased() {
  const [selectOption, setSelectOption] = useState("");
  return (
    <div>
      <div className="card custom-custom py-5 mb-10">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2>Category Based Reports</h2>
            </div>
            <div className="col-md-6">
              <div>
                <label htmlFor="">Select a Report</label>
              </div>
              <Select
                className="form-control"
                placeholder="Select a Report"
                onChange={(value) => setSelectOption(value)}
              >
                <Option value="1">Category wise</Option>
                <Option value="2">Sub Category Products</Option>
              </Select>
            </div>
          </div>
        </div>
      </div>

      {selectOption === "1" && <CategorywiseSales />}
      {selectOption === "2" && <SubCategorywiseSales />}
    </div>
  );
}
